define('nls/messages',{
    "ru": true,
    "fr": true,
    "de": true,
    "pt": true,
    "es": true
});
